import PaymentActionTypes from './types';
// const initialPaymentsData = {
//   code: '',
//   balances: [],
//   totalBalance: 0,
// };

var initialPaymentsData = {};

const defaultState = {
  paymentDetails: { ...initialPaymentsData },
  isFetching: false,
  status: '',
  transactionDetails: {},
  transactionStatusDetails: {},
  statusUpdated: false,
  documentData: {},
};

const consignerPaymentReducer = (state: any = defaultState, action: { type: string; payload: any; response: any }) => {
  switch (action.type) {
    case PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
        paymentDetails: {},
      };
    }

    case PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_SUCCESS: {
      const listData = action.payload?.data || [];

      let newListObj: any = {};
      newListObj = { ...state.paymentDetails };

      newListObj.balances = newListObj?.balances?.length
        ? newListObj.balances.concat(listData.balances)
        : listData.balances;
      // newListObj.companyName = listData.companyName;
      newListObj.code = listData.userCode;
      newListObj.totalBalance = listData?.totalBalanceInPaisa / 100;
      newListObj.tdsAmount = listData?.tdsAmount / 100;
      return { ...state, paymentDetails: listData, isFetching: false };
    }

    case PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_FAILURE: {
      return { ...state, isFetching: false };
    }

    case PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_START: {
      return { ...state, isFetching: true };
    }

    case PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_SUCCESS: {
      const data = action.payload?.data || '';

      return { ...state, isFetching: false, documentData: data };
    }

    case PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_FAILURE: {
      return { ...state, isFetching: false };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_START: {
      return { ...state, isFetching: true };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_SUCCESS: {
      const data = action.payload?.data || '';

      return { ...state, isFetching: false, transactionDetails: data };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_FAILURE: {
      return { ...state, isFetching: false };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_START: {
      return {
        ...state,
        isFetching: true,
        transactionStatusDetails: {},
        // paymentStatus: {},
        // transactionStatusDetails: '',
        status: '',
        errorText: '',
        statusUpdated: false,
        // paymentData: {},
      };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_SUCCESS: {
      const data = action.payload.data;

      let newListObj: any = {};
      newListObj = { ...state.transactionStatusDetails };
      newListObj = data;

      return {
        ...state,
        isFetching: false,
        status: newListObj?.transactionStatusDetails?.data?.data?.status,
        statusUpdated: true,
        transactionStatusDetails: newListObj,
        // paymentStatus: newListObj,
      };
    }

    case PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_FAILURE: {
      return {
        ...state,
        isFetching: false,
        errorText: action.payload.response.data.message,
        transactionStatusDetails: {},
        statusUpdated: false,
      };
    }

    default:
      return { ...state };
  }
};

export default consignerPaymentReducer;
